/**
 * Subsidiary connector lines + grid layout.
 */

import type { EntityNode } from "../types";
import { EntityCard } from "./EntityCard";

export function SubsidiaryTree({
  subsidiaries,
  onDocumentClick,
}: {
  subsidiaries: EntityNode[];
  onDocumentClick?: (documentId: string) => void;
}) {
  const N = subsidiaries.length;
  const cols = Math.min(N, 3);
  const pct = 100 / (2 * cols);

  return (
    <div className="flex w-full max-w-5xl flex-col items-center">
      <div className="h-10 w-0.5 bg-border" />
      <div className="w-full">
        {N > 1 && (
          <div
            className="h-0.5 bg-border"
            style={{
              marginLeft: `${pct}%`,
              marginRight: `${pct}%`,
            }}
          />
        )}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${cols}, 1fr)`,
            gap: "1.5rem",
          }}
        >
          {subsidiaries.map((sub) => (
            <div
              key={sub.acn ?? sub.name}
              className="flex flex-col items-center"
            >
              <div className="h-6 w-0.5 bg-border" />
              <EntityCard node={sub} onDocumentClick={onDocumentClick} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
